import getDefaultTasksFolderDisplayName from './getDefaultTasksFolderDisplayName';
import { flaggedEmailsFolderName } from './getFolderDisplayName.locstring.json';
import loc from 'owa-localize';
import type { TodoFolder } from 'owa-todo-types';

export default function getFolderDisplayName(folder: TodoFolder): string {
    if (folder.IsDefaultFolder) {
        return getDefaultTasksFolderDisplayName();
    } else if (folder.FolderType === 'Commitments') {
        return folder.Name;
    } else if (folder.FolderType === 'FlaggedEmails') {
        return loc(flaggedEmailsFolderName);
    } else {
        return folder.Name;
    }
}
